(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pete-brands"]) return;
  try {
    
function initializePeteBrands(root) {
 if (root.dataset.brandReady) return;
 root.dataset.brandReady = 'true';
 const cards = Array.from(root.querySelectorAll('[data-brand-card]'));
 const search = root.querySelector('[data-brand-search]');
 const count = root.querySelector('[data-brand-count]');
 const buttons = Array.from(root.querySelectorAll('[data-brand-letter]'));
 const empty = root.querySelector('[data-brand-empty]');
 let selected = 'all';
 const letterFor = name => /^[a-z]/i.test(name) ? name[0].toUpperCase() : '#';
 const available = new Set(cards.map(card => letterFor(card.dataset.brandName)));
 buttons.forEach(button => {
  button.disabled = button.dataset.brandLetter !== 'all' && !available.has(button.dataset.brandLetter);
  button.addEventListener('click', () => { selected = button.dataset.brandLetter; filter(); });
 });
 function filter() {
  const term = search.value.trim().toLocaleLowerCase();
  let visible = 0;
  cards.forEach(card => {
   const name = card.dataset.brandName;
   const matches = name.toLocaleLowerCase().includes(term) && (selected === 'all' || letterFor(name) === selected);
   card.hidden = !matches;
   if (matches) visible += 1;
  });
  buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brandLetter === selected)));
  count.textContent = (visible === cards.length ? String(visible) : visible + ' / ' + cards.length) + ' ' + count.dataset.label;
  empty.hidden = visible > 0;
 }
 search.addEventListener('input', () => { selected = 'all'; filter(); });
 root.querySelector('[data-brand-reset]').addEventListener('click', () => { search.value = ''; selected = 'all'; filter(); search.focus(); });
 filter();
}
document.querySelectorAll('[data-pete-brands]').forEach(initializePeteBrands);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pete-brands]').forEach(initializePeteBrands));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pete-collections"]) return;
  try {
    
function initializePeteDirectory(root) {
  if (root.dataset.directoryReady) return;
  root.dataset.directoryReady = 'true';
  const input = root.querySelector('[data-directory-filter]');
  const cards = Array.from(root.querySelectorAll('[data-directory-card]'));
  const count = root.querySelector('[data-directory-count]');
  const empty = root.querySelector('[data-directory-empty]');
  function filterCards() {
    const term = input.value.trim().toLocaleLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const matches = card.dataset.collectionTitle.toLocaleLowerCase().includes(term);
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    count.textContent = (visible === cards.length ? String(visible) : visible + ' / ' + cards.length) + ' ' + count.dataset.label;
    empty.hidden = visible > 0;
  }
  input.addEventListener('input', filterCards);
  filterCards();
}
document.querySelectorAll('[data-pete-directory]').forEach(initializePeteDirectory);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-pete-directory]').forEach(initializePeteDirectory);
});

  } catch(e) { console.error(e); }
})();
})();
